var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddressForm',{on:{"submit":_vm.createAddress},scopedSlots:_vm._u([{key:"submit-button-content",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.$t('Add the address'))+"\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }